import { notification } from 'antd';

export const error = ({ message, description }) => notification.error({ message, description, duration: 0 });
